import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { SharedService } from "../../shared.service";
import notify from "devextreme/ui/notify";
import { Papa } from "ngx-papaparse";
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

@Component({
  standalone: false,
  selector: "app-dx-grid",
  templateUrl: "./dx-grid.component.html",
  styleUrls: ["./dx-grid.component.css"],
})
export class DxGridComponent implements OnInit {
  @Input() dataSource: any;
  @Input() lenseSide: string;
  minQtyList: any[];
  maxQtyList: any[];
  loading: boolean;
  data: any;
  @Output() optSelected: EventEmitter<any> = new EventEmitter();
  @ViewChild('csvfileInput') csvfileInput: ElementRef;
  constructor(private sharedService: SharedService, private papa: Papa) {}

  ngOnInit(): void {
    this.minQtyList = [];
    this.maxQtyList = [];
  }
  /**
   * @name ngOnChanges
   * @desc Fires when change in input properties are detected
   * @return void
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataSource && Object.keys(changes.dataSource.currentValue).length > 0) {
      this.data = changes.dataSource.currentValue;
      this.getPivotTable(
        changes.dataSource.currentValue.sphMin,
        changes.dataSource.currentValue.sphMax,
        changes.dataSource.currentValue.cylMin,
        changes.dataSource.currentValue.cylMax,
        changes.dataSource.currentValue.addMin,
        changes.dataSource.currentValue.addMax,
        changes.dataSource.currentValue.focalId,
        changes.dataSource.currentValue.itemTypeMasterId
      );
    }
  }
  /**
   * @name customizeColumns
   * @param columns array
   * @returns void
   * @description columns settings
   */
  customizeColumns(columns) {
    if (columns.length > 0) {
      columns.forEach((element) => {
        if (element.dataField == "SPH") {
          columns[0].allowEditing = false;
        } else if (element.dataField == "ADDF") {
          columns[0].allowEditing = false;
        } else {
          element.caption = element.dataField.replace(" ", ".");
        }
        if(element.dataField == 'stockLevelDetailId' || element.dataField == 'lensSideId') {
          element.visible = false;      
        }
      });
    }
  }
  
/**
 * @name setColumnDataType
 * @reutrn void
 */
  setColumnDataType(e) {
    if(e && e.column) {
      e.column.dataType = 'number';
    }
  }

  

  /**
   * @name getPivotTable
   * @param {sphMin} string
   * @param {sphMax} string
   * @param {cylMin} string
   * @param {cylMax} string
   * @param {AddfMin} string
   * @param {AddfMax} string
   * @returns Rage list
   * @memberof salesService
   */
  getPivotTable(
    sphMin: any,
    sphMax: any,
    cylMin: any,
    cylMax: any,
    addMin: any,
    addMax: any,
    focalId: any,
    itemTypeMasterId: any
  ) {
    this.loading = true;
    let minQty = [];
    this.sharedService
      .getPivotTable(sphMin, sphMax, cylMin, cylMax, addMin, addMax, focalId, itemTypeMasterId)
      .then((response: any) => {
        if (
          response.data.completed &&
          response.data.payload &&
          response.data.payload.length > 0
        ) {
          this.loading = false;
           minQty = response.data.payload;
           const copyPayload = JSON.stringify(response.data.payload);
          this.minQtyList = minQty;
          this.maxQtyList = JSON.parse(copyPayload);
          if(this.data.stockLevelDetailListMin && this.data.stockLevelDetailListMin.length > 0) {
            this.data.stockLevelDetailListMin.forEach(element => {
              let sph;
              let strCylAddf = this.data.focalId == 1 && this.data.itemTypeMasterId == 2 ? element.strCyl.replace('+','') :  element.strAddf.replace('+','');
              strCylAddf = strCylAddf.replace('.',' ');
              let strSph = element.strSph.replace('+','');
              this.minQtyList.forEach((item: any) => {
                for (const [key, value] of Object.entries(item)) {
                  if(key === 'SPH'){
                    sph = value;
                  }
                  
                 if(strSph == sph && strCylAddf == key && element.minQty != 0){
                      item[key] = element.minQty;
                      item["stockLevelDetailId"] = 0;
                      item['lensSideId'] = element.lensSideId
                 }
                }
              });
              sph = '';
            });
           
          } 
          if(this.data.stockLevelDetailListMax && this.data.stockLevelDetailListMax.length > 0) { 
            this.data.stockLevelDetailListMax.forEach(element => {
              let sph;
              let strCylAddf = this.data.focalId == 1 && this.data.itemTypeMasterId == 2 ? element.strCyl.replace('+','') :  element.strAddf.replace('+','');
              strCylAddf = strCylAddf.replace('.',' ');
              let strSph = element.strSph.replace('+','');
              this.maxQtyList.forEach((item: any) => {
                for (const [key, value] of Object.entries(item)) {
                  if(key === 'SPH'){
                    sph = value;
                  }
                  
                 if(strSph == sph && strCylAddf == key && element.maxQty != 0){
                      item[key] = element.maxQty;
                      item["stockLevelDetailId"] = 0;
                      item['lensSideId'] = element.lensSideId
                 }
                }
              });
              sph = '';
            });
          }
          
        } else {
          this.loading = false;
          this.minQtyList = [];
          this.maxQtyList = [];
          const option = {
            width: 300,
            displayTime: 8000,
            message: response.data.message,
            type: "warnerroring",
          };
          notify(option);
        }
      })
      .catch((error) => {
        this.loading = false;
        const option = {
          width: 300,
          displayTime: 8000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }


  /**
 * @name readCSV
 * @param event 
 * @param listName 
 */
  readCSV(event, listName: string) {
    let files: FileList = event.target.files;
    let ParentArray: any = [];
    let tempData: any = [];
    if (files && files.length > 0) {
        let file: File = files.item(0);
        let reader: FileReader = new FileReader();
        reader.readAsText(file);
        reader.onload = (e) => {
            let csvData: string = reader.result as string;
            this.papa.parse(csvData, {
                complete: (result) => {
                  let filteredData = result.data.slice(1).map((row: any) => row.slice(1));
                  filteredData.map((parentArray, parentArrayIndex) => {
                      ParentArray = parentArray;
                        parentArray.map((v, childArrayIndex) => {
                          console.log('parentArrayIndex', parentArrayIndex + ' ' + 'childArrayIndex' + ' ' + childArrayIndex + ' ' + v)
                            tempData.push(v)
                        })
                        if(listName == 'minQtyList') {
                          this.minQtyList.forEach((item: any, index: any) => {
                            for (const [key, value] of Object.entries(item)) {
                              if(key !== 'SPH') {
                                if(tempData.length == 0)
                                break;
                                if(parentArrayIndex == index) {
                                  item[key] = tempData.shift();
                                }
                              }
                            }
                          });
                        }
                        if(listName == 'maxQtyList') {
                          this.maxQtyList.forEach((item: any, index: any) => {
                            for (const [key, value] of Object.entries(item)) {
                              if(key !== 'SPH') {
                                if(tempData.length == 0)
                                break;
                                if(parentArrayIndex == index) {
                                  item[key] = tempData.shift();
                                }
                              }
                            }
                          });
                        }
                    });
                }
            });
        }
        this.csvfileInput.nativeElement.value = "";
    } 
}

  /**
   * @name savebothSidesForm
   * @returns payload list
   */
  savebothSidesForm() {
    this.optSelected.emit({
      minQtyList: this.minQtyList,
      maxQtyList: this.maxQtyList
    });
  }

  /**
   * Executes when exporting.
   *
   * @param {Object} e - The event object.
   */
  onExporting(e) {
    e.component.beginUpdate();
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('exportData');

    exportDataGrid({
        component: e.component,
        worksheet: worksheet
    }).then(function() {
        workbook.xlsx.writeBuffer().then(function(buffer: BlobPart) {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'exportData.xlsx');
        });
    }).then(function() {
        e.component.endUpdate();
    });
}
}
